import { defineMessages } from 'react-intl';

const messages: {
	threadsListLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	suggestedSpacesSectionHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	threadsListLabel: {
		id: 'rovo-for-you.threads-list.label',
		defaultMessage: 'Threads',
		description: 'Accessible label for the threads list container in the For You tab',
	},
	suggestedSpacesSectionHeading: {
		id: 'rovo-for-you.threads-list.suggested-spaces-section-heading',
		defaultMessage: 'Recommended spaces',
		description: 'Heading for the recommended spaces section in the For You tab',
	},
});

export default messages;
